export default __webpack_public_path__ + "static/media/24.efc0a4a4.jpg";